import { useCallback, useMemo } from 'react';

import * as events from 'src/lib/events';
import { useGetCommonEventAuthAttributes, useGetSystemEventAttributes } from 'src/services';
import { getCdNamesValues } from 'src/lib/events';

const getCipChannel = (channel) => `${channel}_cip`;

export const useCipEvents = () => {
  const getCommonAuthAttributes = useGetCommonEventAuthAttributes();
  const getSystemEventAttributes = useGetSystemEventAttributes();

  const trackToggleTable = useCallback(
    (channel, table) => {
      const dimensions = {
        channel: getCipChannel(channel),
        table,
      };

      events.trackEvent(events.CIP.toggleTable, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackConnectAdAccounts = useCallback(
    (channel, accountIds) => {
      const dimensions = {
        channel: getCipChannel(channel),
        accountIds: accountIds.join(', '),
      };

      events.trackEvent(events.CIP.connectAdAccounts, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackImproveButtonClick = useCallback(
    (channel, generationTool) => {
      const dimensions = {
        channel: getCipChannel(channel),
        generationTool,
      };

      events.trackEvent(events.CIP.improveButtonClick, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackUpdateTag = useCallback(
    (channel, actionType) => {
      const dimensions = {
        channel: getCipChannel(channel),
        actionType,
      };

      events.trackEvent(events.CIP.improveButtonClick, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackPageVisited = useCallback(
    (event) => {
      events.trackEvent(event, {
        ...getCommonAuthAttributes(),
        ...getSystemEventAttributes(),
      });
    },
    [getCommonAuthAttributes, getSystemEventAttributes]
  );

  const trackFilterApplied = useCallback(
    (channel, filterType) => {
      const dimensions = {
        channel: getCipChannel(channel),
        filterType,
      };

      events.trackEvent(events.CIP.filterApplied, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackConnectReviewsAccount = useCallback(
    (channel, url) => {
      const dimensions = {
        channel: getCipChannel(channel),
        url,
      };

      events.trackEvent(events.CIP.reviewsAccountConnected, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  const trackConnectWebsiteAccounts = useCallback(
    (channel, urls) => {
      const dimensions = {
        channel: getCipChannel(channel),
        urls: urls.join(', '),
      };

      events.trackEvent(events.CIP.websiteAccountsConnected, {
        ...getCommonAuthAttributes(),
        ...getCdNamesValues(dimensions),
      });
    },
    [getCommonAuthAttributes]
  );

  return useMemo(
    () => ({
      trackToggleTable,
      trackConnectAdAccounts,
      trackImproveButtonClick,
      trackUpdateTag,
      trackPageVisited,
      trackFilterApplied,
      trackConnectReviewsAccount,
      trackConnectWebsiteAccounts,
    }),
    [
      trackToggleTable,
      trackConnectAdAccounts,
      trackImproveButtonClick,
      trackUpdateTag,
      trackPageVisited,
      trackFilterApplied,
      trackConnectReviewsAccount,
      trackConnectWebsiteAccounts,
    ]
  );
};
